import React from "react";
import TestimonialCarousel from './TestimonialCarousel';
import "../css/Teaching.css";
import Course from "./Course";

const Teaching = () => {
  return (
    <section id="teaching">
        <h1>Teaching</h1>
        <div id="teaching-text">
        <p>My experience as an educator spans over a decade, evolving from math tutoring and teaching assistant roles 
            to lecturer and course developer. These experiences have shaped my overarching teaching goal: <i>to demystify complex theories, problems, and algorithms, 
                revealing their inherent simplicity</i>. At TU/e, I am currently teaching two courses in the Analytics for Transport and Mobility track
                within the master program Operations Management and Logistics. 
        </p>
        </div>
        <Course title="Large-Scale Optimization for Transport & Mobility" description="This course focuses on the application of 
        heuristic optimization methods (constructive heuristics, local search, metaheuristics and matheuristics) to solve large-scale
         problems in the transport and mobility domain." />
        <Course title="Decision-Making in Transport & Mobility" description="This course discusses how practical problems in the field of 
        transport and mobility (e.g., VRPs, network design, line planning and timetabling) can be formulated as mixed-integer linear programmings models, and how these models can be solved using
        optimization software." />
        <TestimonialCarousel />
    </section>
  );
};

export default Teaching;